export const availableGames = [{
    name: 'Snake',
    description: 'Classic snake game.',
    contests: [
        {id: 's1', type: 'Top Score', description: 'Top Score After A Pre-Determined Number Of Rounds (3 Rounds)'},
    ],
    image: process.env.PUBLIC_URL + '/img/snakeExample.png',
},
{
    name: 'Fortnite',
    description: 'Popular Battle Royale game.',
    contests: [
        {id: 'fn1', type: 'Victory Royale', description: 'First One To Get A Victory Royale.'},
        {id: 'fn2', type: 'Eliminations', description: 'First One To Get 10 New Eliminations.'},
    ],
    image: process.env.PUBLIC_URL + '/img/fortniteExample3.jpg',
},
];